















































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import UpdateWorkerEmailAddressUsernameRequest from '@/models/Workers/UpdateWorkerEmailAddressUsernameRequest';

@Component({
  components: { },
    name: 'WorkerEmailAddressUsernameEdit'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public datePicker = false;
  public worker = new WorkerDto();
  public dateOfBirth = '';
  
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateWorkerEmailAddressUsernameRequest();
    request.updatedAt = this.worker.updatedAt;
    request.emailAddress = this.worker.emailAddress;

    await WorkerDetailsModule.editEmailAddressUsername(request)
    this.dialog = false;
  }


  
}
